import {
    Component, DestroyRef, inject, ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { OrganizationService } from 'src/app/services/organization.service';
import { ApolloService } from 'src/gql-generated/generated';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { ConnectionService } from 'src/app/services/connection.service';
import { TableComponent, TableSettings } from '../../shared/table/table.component';
import { NgClass, NgIf, DatePipe } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrl: './users.component.scss',
    imports: [
        NgClass,
        NgIf,
        MatFormField,
        MatInput,
        ReactiveFormsModule,
        MatButton,
        RouterLink,
        TableComponent,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatTooltip,
        MatIcon,
        DatePipe,
    ],
})
export class UsersComponent {
    /**
     * Reference to users table
     */
    @ViewChild('table') table?: TableComponent;

    /**
     * Custom search control
     */
    searchControl = new FormControl('');

    /**
     * Settings for users table
     */
    userTableSettings: TableSettings = {
        getItems: (paginator, search) => firstValueFrom(this.apollo.getUsers({
            limit: paginator.pageSize,
            offset: paginator.pageSize * paginator.pageIndex,
            where: {
                deleted_at: { _is_null: true },
                _or: [
                    { name: { _ilike: `%${search}%` } },
                    { email: { _ilike: `%${search}%` } },
                ],
                organization_id: { _eq: this.organization.currentOrganization$.value?.id },
            },
        })),
        routerLinkFunction: (item) => {
            if (item.role === 'admin' && this.userService.profile.role === 'manager') {
                return '';
            }
            return `/settings/users/${item.id}`;
        },
        hideSearch: true,
        hidePageSize: true,
    };

    /**
     * Destroy ref used in takeUntilDestroyed
     */
    private destroyRef = inject(DestroyRef);

    constructor(
        private apollo: ApolloService,
        public organization: OrganizationService,
        public breakpoint: BreakpointService,
        public connection: ConnectionService,
        public userService: UserService,
    ) { }

    /**
     * Logic after view is initialzied
     */
    ngAfterViewInit(): void {
        // Pass local searchControl values to table searchControl
        if (this.table) {
            this.searchControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((s) => this.table?.searchControl.setValue(s));
        }
    }
}
